import { render, staticRenderFns } from "./AssetEditor.vue?vue&type=template&id=771d3e6f&scoped=true&"
import script from "./AssetEditor.vue?vue&type=script&lang=ts&"
export * from "./AssetEditor.vue?vue&type=script&lang=ts&"
import style0 from "./AssetEditor.vue?vue&type=style&index=0&id=771d3e6f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771d3e6f",
  null
  
)

export default component.exports